import { render, staticRenderFns } from "./NutrientSelectionTab.vue?vue&type=template&id=944cd306&scoped=true"
import script from "./NutrientSelectionTab.vue?vue&type=script&lang=js"
export * from "./NutrientSelectionTab.vue?vue&type=script&lang=js"
import style0 from "./NutrientSelectionTab.vue?vue&type=style&index=0&id=944cd306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944cd306",
  null
  
)

export default component.exports